import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { useFormik } from 'formik';
import PrimaryModal from '../../components/UI/Modal/PrimaryModal';
import { PrimaryButton } from "../../components/UI";
import SuccessModal from '../../components/UI/Modal/SuccessModal';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const Verification = ({ user_id }) => {
    const { auth } = useContext(AuthContext);
    const { content } = useContentfulContext();
    const [showResendOTPModal, setShowResendOTPModal] = useState(false);
    const [verifySuccess, setVerifySuccess] = useState(false);
    const navigate = useNavigate();
    // useEffect(() => {
    //     if(!sessionStorage.getItem('verify_otp')) {
    //         navigate('/auth/register');
    //     }
    // }, []);

    // const { auth, setAuth } = useContext(AuthContext);

    // const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    // const [error, setError] = useState('');
    // const navigate = useNavigate();

    // const handleOtpChange = (e, index) => {
    //     if (isNaN(e.target.value)) return false;
    //     setOtp([...otp.map((d, idx) => (idx === index) ? e.target.value : d)]);
    // }

    // const handleKeyEvent = (e) => {
    //     if (e.key == 'Backspace') {
    //         e.target.previousSibling && e.target.previousSibling.focus();
    //     } else if (/^\d+$/.test(e.target.value)) {
    //         e.target.nextSibling && e.target.nextSibling.focus();
    //     }
    // }

    // const validateOTPHandler = () => {

    //     var myHeaders = new Headers();
    //     myHeaders.append("Content-Type", "text/plain");

    //     var formData = {
    //         'verification_code': otp.join(''),
    //         'user_internal_id': localStorage.getItem('user_internal_id')
    //     }
    //     var requestOptions = {
    //         method: 'POST',
    //         headers: myHeaders,
    //         body: JSON.stringify(formData),
    //         redirect: 'follow'
    //     };

    //     fetch("https://script.google.com/macros/s/AKfycbw8cZKVu5GeSJscfQ7Rdzthsh2MTUTo06vmf4qh6kLBggArE98aZ0rNAOw4o_npb7ALtA/exec?action=verification", requestOptions)
    //         .then(response => response.json())
    //         .then(result => {
    //             if (result.status_code == 200) {
    //                 setAuth((prev) => {
    //                     return { ...prev, user_verification: true };
    //                 })
    //                 setError('User successfully registered')
    //                 navigate('/account');
    //             } else if (result.status_code == 300) {
    //                 setError('Please enter valid OTP')
    //             }
    //         })
    //         .catch(error => console.log('error', error));
    // }

    const initialValues = {
        otp: [
            { digit: "" },
            { digit: "" },
            { digit: "" },
            { digit: "" },
            { digit: "" },
            { digit: "" }
        ]
    };

    const formik = useFormik({
        initialValues,
        onSubmit: async (values) => {
            // setVerifySuccess(true);
        }
    });

    const handleOTPChange = (
        event,
        element
    ) => {
        if (event.target.value === "" || !/^\d+$/.test(event.target.value)) {
            return;
        }
        formik.setFieldValue(element, event.target.value);
        const nextElementSibling = event.target.nextElementSibling;

        if (nextElementSibling) {
            nextElementSibling.focus();
        }
    };

    const inputOnKeyDown = (
        e,
        element
    ) => {
        const target = e.target;
        formik.setFieldValue(element, "");

        if (e.key !== "Backspace" || e.target.value !== "") {
            return;
        }

        const previousElementSibling = target.previousElementSibling;

        if (previousElementSibling) {
            previousElementSibling.focus();
        }
    };

    return (
        <section>
            <div className="mx-auto flex flex-col md:flex-row justify-center items-center max-w-[75%] my-12">
                <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start text-center">
                    <div className="space-y-4 md:space-y-6 w-full">
                        {showResendOTPModal && <PrimaryModal title={content.VERIFICATION_CONTENT.resend_code_modal.title} hideModal={() => { setShowResendOTPModal(false) }} >
                            <div className="px-6 py-6 lg:px-8 text-center">
                                <p className='font-medium text-primary-600 mb-4'>{content.VERIFICATION_CONTENT.resend_code_modal.description}</p>
                                <PrimaryButton handleClick={() => { setShowResendOTPModal(false) }}>Close</PrimaryButton>
                            </div>
                        </PrimaryModal>}
                        {verifySuccess && <SuccessModal title="Verification Successful" hideModal={() => { 
                            navigate('/');
                            setVerifySuccess(false);
                        }}>
                            <div className="px-6 py-6 lg:px-8 text-center">
                                <p className='font-medium text-primary-600 mb-4'>{content.VERIFICATION_CONTENT.success_msg}</p>
                                <PrimaryButton handleClick={() => { 
                                    navigate('/');
                                    setVerifySuccess(false);
                                }}>{content.VERIFICATION_CONTENT.login_cta}</PrimaryButton>
                            </div>
                        </SuccessModal>}
                        <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{content.VERIFICATION_CONTENT.title}</h1>
                        <div className="flex flex-col mt-4">
                            <p className='font-medium text-primary-600'>{content.VERIFICATION_CONTENT.instruction_text.received_code_text}</p>
                            <p className='font-medium text-primary-600'>{auth.email}</p>
                        </div>
                        <div id="verification-code" className="flex flex-row justify-center text-center px-2 mt-5">
                            {initialValues.otp.map((item, index) => {
                                return (
                                    <input className="w-16 h-16 mx-2 flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-2 text-lg bg-white focus:ring-1 ring-primary" type="text" name="" id="" maxLength="1" 
                                        {...formik.getFieldProps(`otp.${index}.digit`)}
                                        onChange={(event) =>
                                            handleOTPChange(event, `otp.${index}.digit`)
                                        }
                                        onKeyDown={(event) =>
                                            inputOnKeyDown(event, `otp.${index}.digit`)
                                    } />
                                );
                            })}
                        </div>
                        <div className="mb-4 px-2">
                            <button type="submit" className="w-full text-white bg-primary hover:bg-primary focus:ring-4 focus:outline-none font-medium rounded-lg px-5 py-3 text-center" onClick={() => { setVerifySuccess(true) }}>{content.VERIFICATION_CONTENT.verify}</button>
                        </div>
                        <div className="flex justify-center text-center mt-5">
                            <a className="flex items-center text-primary hover:text-primary cursor-pointer hover:underline text-sm" onClick={() => setShowResendOTPModal(true)}><span className="font-bold">{content.VERIFICATION_CONTENT.resend_cta}</span><i className='bx bx-caret-right ml-1'></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Verification;